import { Select } from "@chakra-ui/react";
import React, { useState } from "react";
import Loader from "./Loader";
import Message from "./Message";
import RingSizeDialog from "./RingSizeDialog"

const RingSizeSelector = ({
    loadingSize,
    errorSize,
    sizes,
    selectedProduct,
    selectedSizeMen,
    setSelectedSizeMen,
    selectedSizeWomen,
    setSelectedSizeWomen,
}) => {

    const [isRingSize, setIsRingSize] = useState(false);

    const isCoupleRing = selectedProduct?.subcategories?.some(
        (subcat) => subcat.name === "Couple Rings"
    );

    const gender = selectedProduct?.gender;

    const renderSizeOptions = () => {
        if (loadingSize) return <Loader />;
        if (errorSize) return <Message type="error">{errorSize}</Message>;
        return sizes.map((num) => (
            <option key={num?.size} value={num?.size}>
                {num?.size}
            </option>
        ));
    };

    return (
        <div>
            <div className="flex items-center gap-2 mb-2">
                <label htmlFor="sizeSelect">Ring Size:</label>

                <div
                    className="underline cursor-pointer text-sm text-[#000080]"
                    onClick={() => setIsRingSize(true)}
                >
                    Size Chart
                </div>

            </div>

            {isCoupleRing ? (
                <div className="flex gap-6 mt-2">
                    <div className="flex items-center gap-2">
                        <div>
                            <label htmlFor="sizeMen" className="whitespace-nowrap">Men Size</label>
                            <Select
                                id="sizeMen"
                                border="1px solid"
                                _hover="none"
                                className="px-4 pt-0 mt-2"
                                pt="0px"
                                width="40"
                                borderColor="#000080"
                                value={selectedSizeMen}
                                onChange={(e) => setSelectedSizeMen(e.target.value)}
                                required
                            >
                                <option value={0}>Select Size Men (Indian)</option>
                                {renderSizeOptions()}
                            </Select>
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        <div>
                            <label htmlFor="sizeWomen" className="whitespace-nowrap">Women Size</label>
                            <Select
                                id="sizeWomen"
                                border="1px solid"
                                _hover="none"
                                pt="0px"
                                width="40"
                                className="px-4 pt-0 mt-2"
                                borderColor="#000080"
                                value={selectedSizeWomen}
                                onChange={(e) => setSelectedSizeWomen(e.target.value)}
                                required
                            >
                                <option value={0}>Select Size Women (Indian)</option>
                                {renderSizeOptions()}
                            </Select>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex items-center gap-2 mt-2">
                    {/* <label htmlFor="sizeSelectSingle" className="whitespace-nowrap">Size:</label> */}
                    <Select
                        id="sizeSelectSingle"
                        border="1px solid"
                        _hover="none"
                        pt="0px"
                        width="40"
                        borderColor="#000080"
                        value={gender === "male" ? selectedSizeMen : selectedSizeWomen}
                        onChange={(e) => {
                            if (gender === "male") {
                                setSelectedSizeMen(e.target.value);
                            } else {
                                setSelectedSizeWomen(e.target.value);
                            }
                        }}
                        required
                    >
                        <option value={0}>Select Size (Indian)</option>
                        {renderSizeOptions()}
                    </Select>
                </div>
            )}

            <RingSizeDialog
                isOpen={isRingSize}
                onClose={() => setIsRingSize(false)}
                loadingSize={loadingSize}
                errorSize={errorSize}
                sizes={sizes}
            />
        </div>
    );
};

export default RingSizeSelector;
